import { render, staticRenderFns } from "./FocusAreasProjectThree-View.vue?vue&type=template&id=8f4e9316&scoped=true&"
import script from "./FocusAreasProjectThree-View.vue?vue&type=script&setup=true&lang=js&"
export * from "./FocusAreasProjectThree-View.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4e9316",
  null
  
)

export default component.exports